/* eslint @typescript-eslint/no-explicit-any: 0 */
import { IDatahubCase, ISimplifiedVisualMaterial, MaterialApi } from 'api';
import { Container } from 'components';
import { useLocalization } from 'localization';
import queries from 'modules/common/queries';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { View, ViewOff } from '@carbon/icons-react';
import format from 'localization/format';

import Styled from './Styled';

export interface IMaterialItemMeta
  extends Pick<ISimplifiedVisualMaterial, 'updatedDate' | 'description' | 'isActive' | 'id'> {
  /** Name editing callback */
  onDescriptionEdit?: (
    name: ISimplifiedVisualMaterial['description'],
    materialId: ISimplifiedVisualMaterial['id']
  ) => void;
  caseId?: IDatahubCase['id'];
}

const MaterialItemMeta: FC<IMaterialItemMeta> = React.memo(
  ({ onDescriptionEdit, updatedDate, description, id, isActive, caseId }) => {
    const { t } = useLocalization();
    const [searchKey, setSearchKey] = useState(description || '');

    const { data: suggestedNames = [] } = useQuery({
      queryKey: [queries.suggestedMaterialNames],
      queryFn: async () => (caseId ? await MaterialApi.getSuggestedMaterialNames(caseId) : undefined),
      enabled: !!onDescriptionEdit && !!caseId,
    });

    const filteredNames = useMemo(
      () => suggestedNames.filter(suggestion => suggestion.includes(searchKey)),
      [searchKey, suggestedNames]
    );

    useEffect(() => {
      setSearchKey(description || '');
    }, [description]);

    throw new Error('// TODO: [EP-588] Double check if this is necessary.');
    // return (
    //   <Container padding="xxs">
    //     <Container display="flex" alignItems="center" justifyContent="space-between">
    //       {onDescriptionEdit ? (
    //         <AutoComplete
    //           searchValue={searchKey}
    //           onClick={e => e.stopPropagation()}
    //           placeholder={`${t('common.terms.name')}...`}
    //           onSearch={value => setSearchKey(value)}
    //           onSelect={value => {
    //             onDescriptionEdit(value, id);
    //           }}
    //           onBlur={e => {
    //             onDescriptionEdit((e.target as any).value, id);
    //           }}
    //           showSearch
    //           bordered={false}
    //           filterOption={false}
    //         >
    //           {filteredNames.map((suggestion, index) => (
    //             <AutoComplete.Option key={suggestion + index} value={suggestion}>
    //               {suggestion}
    //             </AutoComplete.Option>
    //           ))}
    //         </AutoComplete>
    //       ) : (
    //         <Styled.Name ellipsis>{description || <>&nbsp;</>}</Styled.Name>
    //       )}
    //       {isActive ? <View size={16} /> : <ViewOff size={16} />}
    //     </Container>
    //     <Container display="flex" alignItems="center" justifyContent="space-between">
    //       <Typography.Text type="secondary">
    //         {updatedDate ? format(updatedDate, { date: 'short' }) : <>&nbsp;</>}
    //       </Typography.Text>
    //     </Container>
    //   </Container>
    // );
  }
);

export default MaterialItemMeta;
